import React from 'react';
import PropTypes from 'prop-types';
import { remotePaths } from 'router/routes';

export function DetailsLink({ sum = 0 }) {
  if (+sum === 0) {
    return null;
  }

  return (
    <a href={remotePaths.taxes} className="link">
      Детальная информация
    </a>
  );
}

DetailsLink.propTypes = {
  sum: PropTypes.number,
};
